import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function EquipmentDetailsChart() {
    const data = {
        labels: ["Ventilator", "Dialyzer", "Oxygen Cylinder"],
        datasets: [
            {
                label: "Used",
                data: [30, 60, 30],
                backgroundColor: "#8EE6C9",
                borderColor: "#FFFFFF",
                borderWidth: 1.5,
                borderSkipped: false,
                barThickness: 22,
            },
            {
                label: "Booked",
                data: [25, 30, 120],
                backgroundColor: "#F9C36B",
                borderColor: "#FFFFFF",
                borderWidth: 1.5,
                borderSkipped: false,
                barThickness: 22,
            },
            {
                label: "Unused",
                data: [145, 45, 20],
                backgroundColor: "#E97787",
                borderColor: "#FFFFFF",
                borderWidth: 1.5,
                borderSkipped: false,
                barThickness: 22,
            },
        ],
    };

    const options = {
        indexAxis: "y" as const,
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                left: 20,
                right: 20,
                top: 10,
                bottom: 10,
            },
        },
        scales: {
            x: {
                stacked: true,
                min: 0,
                max: 250,
                ticks: {
                    stepSize: 50,
                    color: "#6B7280",
                    font: { size: 13 },
                },
                grid: {
                    display: true,
                    color: "#EDF1F7",
                    lineWidth: 1,
                },
                border: {
                    display: false,
                },
            },
            y: {
                stacked: true,
                ticks: {
                    color: "#6B7280",
                    font: { size: 14 },
                },
                grid: {
                    display: true,
                    color: "#EDF1F7",
                    lineWidth: 1,
                },
                border: {
                    display: false,
                },
                categoryPercentage: 0.72, // row spacing
                barPercentage: 0.95,      // tiny gap
            },
        },
        plugins: {
            legend: {
                position: "bottom" as const,
                labels: {
                    usePointStyle: true,
                    pointStyle: "circle",
                    padding: 30,
                    boxWidth: 10,
                    color: "#111827",
                    font: { size: 14 },
                },
            },
            tooltip: {
                enabled: true,
                backgroundColor: "#FFFFFF",
                titleColor: "#111827",
                bodyColor: "#374151",
                borderColor: "#E5E7EB",
                borderWidth: 1,
                cornerRadius: 8,
                padding: 10,
                displayColors: false,
                titleFont: {
                    size: 13,
                    weight: "bold" as const,
                },
                bodyFont: {
                    size: 12,
                },
                callbacks: {
                    title: (items: any) => items[0].label,
                    label: (item: any) => `${item.dataset.label}: ${item.raw}`,
                },
            },

        },
    };

    return (
        <div
            style={{
                background: "#FFFFFF",
                borderRadius: 12,

                boxShadow: "0px 2px 8px rgba(0,0,0,0.06)",
                maxWidth: "100%",
                width: "100%"
            }}
            className="p-4"
        >
            <span className="text-18 font-medium text-primary mx-2">
                Equipment Details
            </span>

            <p className="mx-2 pt-2" style={{ color: "#6B7280", fontSize: 14 }}>
                No. of Equipment's: <strong style={{ color: "#111827" }}>5</strong>
            </p>

            <div style={{ height: 280 }}>
                <Bar data={data} options={options} />
            </div>
        </div>
    );
}
